@if (isLoading$ | async) {
  <div class="flex--row loading-view">
    <ino-spinner [type]="type || 'bounce'" [width]="width || 40" [height]="height || 40" />
  </div>
}
<ng-content />
